// Styles for OffersMerchandisingSmallBanner go here.
import styled from 'styled-components';

export const StyledOffersMerchandisingSmallBanner = styled.div``;
